var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTjcl = function SvgTjcl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tjcl_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.838 25.493-6.89-4.331v21.656l6.89-.984v-16.34Z",
    fill: "#80D0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11 13.045v30.167H6.65a2.067 2.067 0 0 0 0 4.135h41.048l-5.513-6.104-9.843 1.379V8.152a3.15 3.15 0 0 0-3.975-3.04l-16.64 4.512a3.544 3.544 0 0 0-2.617 3.42Z",
    fill: "url(#tjcl_svg__b)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.623,
    y: 18.209,
    width: 11.813,
    height: 3.544,
    rx: 1.772,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.623,
    y: 25.69,
    width: 11.813,
    height: 3.544,
    rx: 1.772,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.623,
    y: 33.171,
    width: 11.813,
    height: 3.544,
    rx: 1.772,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 13.325,
    y: 12.187,
    width: 47.852,
    height: 47.852
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#tjcl_svg__c)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12,
    d: "m41.724 42.867-.507.319c-3.817 2.405-8.923 1.944-12.247-1.38-3.86-3.859-3.86-10.116 0-13.975 3.858-3.858 10.115-3.858 13.974 0 3.324 3.325 3.785 8.43 1.38 12.248l-.32.507 3.951 3.95a1.613 1.613 0 0 1-2.28 2.281l-3.951-3.95Z",
    fill: "url(#tjcl_svg__d)",
    stroke: "url(#tjcl_svg__e)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.078 30.032a.984.984 0 0 1 1.158-.773c1.838.368 3.16 1.817 3.928 3.814a.984.984 0 1 1-1.838.707c-.624-1.623-1.53-2.4-2.476-2.59a.984.984 0 0 1-.772-1.159Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tjcl_svg__b",
    x1: 26.14,
    y1: 5,
    x2: 26.14,
    y2: 47.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018DD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tjcl_svg__d",
    x1: 28.439,
    y1: 27.301,
    x2: 48.486,
    y2: 47.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1069FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tjcl_svg__e",
    x1: 28.439,
    y1: 27.301,
    x2: 48.486,
    y2: 47.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1CCF9",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tjcl_svg__c",
    transform: "translate(-13.325 -12.187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.724 42.867-.507.319c-3.817 2.405-8.923 1.944-12.247-1.38-3.86-3.859-3.86-10.116 0-13.975 3.858-3.858 10.115-3.858 13.974 0 3.324 3.325 3.785 8.43 1.38 12.248l-.32.507 3.951 3.95a1.613 1.613 0 0 1-2.28 2.281l-3.951-3.95Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tjcl_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h54v54H0z"
  })))));
};

export default SvgTjcl;